import { baseApi, clearAllVouchers, clearTokens, clearUser, config, selectAuthorizationHeader, selectRefreshToken, SESSION_MAINTENANCE_EVENT, setTokens, } from '@ibk/shared-config';
import { clearDatadogUser } from '@ibk/shared-datadog';
import { LoginErrorsType } from '@ibk/shared-types';
import { localStorageService, StorageKeys } from '@ibk/shared-utils';
export const authApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation({
            query: ({ documentNumber, password }) => {
                const cleanDocumentNumber = documentNumber.replace(/\D/g, '');
                return {
                    url: '/v1/auth/login',
                    method: 'POST',
                    body: { documentNumber: cleanDocumentNumber, password },
                };
            },
            async onQueryStarted() {
                try {
                }
                catch (error) {
                    console.error('Login failed:', error);
                }
            },
            invalidatesTags: ['Auth', 'PersonAccess'],
        }),
        logout: builder.mutation({
            queryFn: async () => {
                return { data: undefined };
            },
            async onQueryStarted(arg, { dispatch }) {
                console.log('Logging out, clearing tokens and user data');
                dispatch(clearTokens());
                dispatch(clearUser());
                dispatch(clearAllVouchers());
                clearDatadogUser();
            },
            invalidatesTags: ['Auth'],
        }),
        serverLogout: builder.mutation({
            async queryFn(_arg, api) {
                const state = api.getState();
                let refreshToken = selectRefreshToken(state);
                if (!refreshToken) {
                    refreshToken = localStorageService.getItemSync(StorageKeys.AuthRefreshToken);
                }
                const authHeader = selectAuthorizationHeader(state) ||
                    (() => {
                        const jwt = localStorageService.getItemSync(StorageKeys.AuthToken);
                        return jwt ? `Bearer ${jwt}` : null;
                    })();
                if (!refreshToken || !authHeader) {
                    return { data: undefined };
                }
                try {
                    await fetch(`${config.apiBaseUrl}/v1/auth/logout`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: authHeader,
                        },
                        body: JSON.stringify({ refresh_token: refreshToken }),
                    });
                }
                catch {
                }
                return { data: undefined };
            },
        }),
        validatePassword: builder.query({
            query: ({ username, password, selectedCompanyId }) => {
                const cleanUsername = username.replace(/\D/g, '');
                return {
                    url: '/v1/auth/validate-access',
                    method: 'POST',
                    body: { username: cleanUsername, password, target: selectedCompanyId },
                };
            },
        }),
        refreshToken: builder.mutation({
            query: ({ refreshToken }) => ({
                url: '/v1/auth/token',
                method: 'POST',
                body: { refreshToken },
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    if (data.result) {
                        dispatch(setTokens({
                            accessToken: data.result.jwtToken,
                            refreshToken: data.result.refreshToken,
                            expiresIn: Math.floor((data.result.jwtTokenExpiration - Date.now()) / 1000),
                            refreshExpiresIn: Math.floor((data.result.refreshTokenExpiration - Date.now()) / 1000),
                            tokenType: 'Bearer',
                        }));
                    }
                }
                catch (error) {
                    dispatch(clearTokens());
                    const { status, data } = error.error ?? {};
                    if (status === 503 && data?.code === LoginErrorsType.MAINTENANCE && typeof window !== 'undefined') {
                        window.dispatchEvent(new CustomEvent(SESSION_MAINTENANCE_EVENT));
                    }
                }
            },
            invalidatesTags: ['Auth'],
        }),
    }),
});
export const { useLoginMutation, useLogoutMutation, useRefreshTokenMutation, useLazyValidatePasswordQuery, useServerLogoutMutation, } = authApi;
